import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';

const COLORS = {
    success: { border: '#2ecc71', icon: '✓' },
    warning: { border: '#de2c49', icon: '!' },
    danger:  { border: '#de2c49', icon: '!' },
    info:    { border: '#3498db', icon: 'i' },
    primary: { border: '#de2c49', icon: '✓' },
    rose:    { border: '#de2c49', icon: '✓' },
};

const useStyles = createUseStyles({
    toast: {
        position: 'fixed',
        top: '16px',
        left: '292px',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.14)',
        padding: '14px 16px',
        minWidth: '280px',
        maxWidth: '380px',
        gap: '12px',
        borderLeft: ({ color }) => `4px solid ${COLORS[color]?.border || '#de2c49'}`,
        animation: '$slideIn 0.2s ease',
    },
    '@keyframes slideIn': {
        from: { opacity: 0, transform: 'translateY(-8px)' },
        to:   { opacity: 1, transform: 'translateY(0)' },
    },
    iconBubble: {
        flexShrink: 0,
        width: '26px',
        height: '26px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '700',
        fontSize: '13px',
        color: '#fff',
        background: ({ color }) => COLORS[color]?.border || '#de2c49',
    },
    message: {
        flex: 1,
        fontSize: '14px',
        fontWeight: '500',
        color: '#333',
        lineHeight: '1.4',
    },
    closeBtn: {
        flexShrink: 0,
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#bbb',
        fontSize: '16px',
        lineHeight: 1,
        padding: '0 2px',
        '&:hover': { color: '#888' },
    },
});

export default function SnackbarCustom(props) {
    const { message, color = 'info', open, closeNotification } = props;
    const classes = useStyles({ color });
    const timerRef = useRef(null);

    const handleClose = () => {
        if (closeNotification) closeNotification();
    };

    useEffect(() => {
        if (open) {
            timerRef.current = setTimeout(handleClose, 5000);
        }
        return () => clearTimeout(timerRef.current);
    }, [open]);

    if (!open) return null;

    const { icon } = COLORS[color] || COLORS.info;

    return ReactDOM.createPortal(
        <div className={classes.toast}>
            <div className={classes.iconBubble}>{icon}</div>
            <span className={classes.message}>{message}</span>
            <button className={classes.closeBtn} onClick={handleClose}>✕</button>
        </div>,
        document.body
    );
}

SnackbarCustom.defaultProps = {
    color: 'info',
};

SnackbarCustom.propTypes = {
    message: PropTypes.node.isRequired,
    color: PropTypes.oneOf(['info', 'success', 'warning', 'danger', 'primary', 'rose']),
    icon: PropTypes.object,
    place: PropTypes.oneOf(['tl', 'tr', 'tc', 'br', 'bl', 'bc']),
    open: PropTypes.bool,
    closeNotification: PropTypes.func,
};
